import { createAsyncThunk } from "@reduxjs/toolkit";

import { GET_NOTIFICATIONS } from "constants/apiEndpoints";
import { setNotifications } from "../slices/notification";
import axiosInstance from "services/api/axiosInstance";

export const processNotifications = createAsyncThunk(
  "notification/fetch",
  async (_, { dispatch, getState }) => {
    const providerId = getState().user?.user?.provider_id;
    const role = getState().user?.user?.role;
    const userId = getState().user?.user?.id;
    try {
      const getNotificationsApiResponse = await axiosInstance.get(
        GET_NOTIFICATIONS,
        {
          params: {
            userId,
            providerId,
            ...(role != 'provider' ? {notification_type: "full_notification"} : {}),
            type: 'no-pagination'
          },
        }
      );

      if (getNotificationsApiResponse?.data?.success) {
        dispatch(setNotifications(getNotificationsApiResponse?.data?.data?.notifications));
        const notifications = getNotificationsApiResponse?.data?.data?.notifications || [];
        const unreadCount = notifications.filter(
          (n) => role != 'provider' ? n.status == "PENDING" : n.sender_read == true
        ).length;

        return { unreadCount, notifications };
      }
      return { unreadCount: 0, notifications: [] };
    } catch (err) {
      console.error(err);
      return { unreadCount: 0, notifications: [] };
    }
  }
);
